<template>
  <span>
    <table
      v-for="(item, index) in itemDetail.targets"
      :key="item.id"
      border="0"
      cellspacing="10"
      style="width:100%; border-left: 0"
    >
      <tr v-if="itemDetail.targets.length > 1">
        <td style="border-left: 0" colspan="5" class="text_center">
          资产信息{{index + 1}}
        </td>
      </tr>

      <tr>
        <td class="w_td font_w_bold">不动产类型</td>
        <td class="td_val  text_left">
          {{ item.immovableType }}
        </td>
        <td class="w_td font_w_bold">规划要求</td>
        <td class="td_val  text_left">
          {{ planningKey[item.planning] }}
        </td>
      </tr>

      <tr>
        <td class="w_td font_w_bold">资产名称</td>
        <td class="td_val text_left">
          {{ item.name }}
        </td>
        <td class="w_td font_w_bold">资产编号</td>
        <td class="td_val text_left">
          {{ item.assetCode }}
        </td>
      </tr>

      <tr v-if="item.assetCategoryTopName">
        <td class=" font_w_bold">资产类型</td>
        <td class="td_val text_left" colspan="4">
          {{item.assetCategoryTopName}}
        </td>
      </tr>

      <tr>
        <td class="font_w_bold">构筑物类型</td>
        <td class="td_val text_left">
          {{ item.structure }}
        </td>
        <td class="font_w_bold">权属证书号</td>
        <td
          class="td_val text_left"
        >
          {{ item.ownershipNo }}
        </td>

      </tr>

      <tr>
        <td class="font_w_bold">转出面积</td>
        <td
          colspan="4"
          class="text_left"
        >
          {{ item.quantity }}{{ item.quantity? itemDetail.quantityUnitName :'' }}
        </td>
      </tr>

      <tr>
        <td class="font_w_bold">坐落</td>
        <td
          colspan="4"
          class="text_left"
        >
          {{ item.address }}
        </td>
      </tr>

      <tr>
        <td class="w_td font_w_bold">东至</td>
        <td class="td_val text_left">
          {{ item.east }}
        </td>
        <td class="w_td font_w_bold">南至</td>
        <td
          class="td_val  text_left"
        >
          {{ item.south }}
        </td>
      </tr>

      <tr>
        <td class="w_td font_w_bold">西至</td>
        <td class="td_val text_left">
          {{ item.west }}
        </td>
        <td class="w_td font_w_bold">北至</td>
        <td
          class="td_val  text_left"
        >
          {{ item.north }}
        </td>
      </tr>

      <tr>
        <td class="font_w_bold">其他描述</td>
        <td class="text_left " colspan="4">
          {{ item.remark }}
        </td>
      </tr>
      <tr>
        <td class="font_w_bold">资产用途</td>
        <td class="text_left " colspan="4">
          {{ assetPurposeKey[item.assetPurpose] }}
        </td>
      </tr>
    </table>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { numberTranToCN } from '@/utils'
export default {

  props: {
    itemDetail: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters(['planningKey', 'quantityUnitKey','assetPurposeKey']),

    // 数字转中文
    numberTranToCN() {
      return function(num) {
        return numberTranToCN(num)
      }
    }
  }
}
</script>

<style scoped lang="scss">
table {

    .w_td {
      min-width: 147px;
    }
    //最大单元格宽度
    .td_val {
      width: 390px;
    }

    tr {

      td {

        box-sizing: border-box;
        padding: 20px;
        border-top: 1px solid #e6e6e6;
        border-right: 1px solid #e6e6e6;
        word-break: break-word;

      }
    }

    .table_title {
      padding: 0 18px;
      box-sizing: border-box;
      width: 82px;
      line-height: 34px;
      font-size: 18px;
      background: #eaf2fa;
    }

  }
</style>
